import eagle from '../assets/images/eagle.png'
import { ROUTES } from '@/config/types'
import { Fade, Zoom } from 'react-awesome-reveal'
import { store } from '@/store/store'
import { setNavigation } from '@/store/slices/appSlice'

export const CTA = ({ title, description = undefined, ctaText="Free Consultation" ,image=eagle}) => {
    return <Zoom triggerOnce={true} direction='up'>
        <div className=" banner  h-auto no-parallalex" style={{ backgroundImage: `url(${image})` }}>
            <div className="overlay black"></div>

            <div className="container py-80 d-flex   justify-content-center align-items-center ">
                <div className="row justify-content-center align-items-center py-lg-3">
                    <div className="col-xl-8">
                        <Fade triggerOnce={true} delay={1000}>
                            <h2 className='text-white-always text-center stroke-animation'
                                dangerouslySetInnerHTML={{ __html: title }}
                            />
                        </Fade>
                        <Fade triggerOnce={true} delay={1200}>
                            {description && <p className='text-white-always text-center mt-3 ' dangerouslySetInnerHTML={{ __html: description }} />}
                        </Fade>
                        <div className="d-flex justify-content-center mt-3">
                        <Fade triggerOnce={true} delay={1400}>
                                <a
                                    href={ROUTES.CONTACT}
                                    className="theme-btn btn-filled w-auto border-0"
                                    onClick={(event) => {
                                        event.preventDefault()
                                        store.dispatch(setNavigation(ROUTES.CONTACT))
                                    }}
                                >
                                    <span>{ctaText}</span>
                                </a>
                          </Fade>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </Zoom>
}
